var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toggle 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2853",
    width: 22.4,
    height: 12.8,
    rx: 6.4,
    transform: "matrix(-1 0 0 1 22.3999 1.59998)",
    fill: "#41A451"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check circle",
    filter: "url(#filter0_d_458_34772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 3.19995C13.3506 3.19995 11.2002 5.35035 11.2002 7.99995C11.2002 10.6496 13.3506 12.8 16.0002 12.8C18.6498 12.8 20.8002 10.6496 20.8002 7.99995C20.8002 5.35035 18.6498 3.19995 16.0002 3.19995ZM14.9554 10.5848L12.5554 8.18484L13.2322 7.50804L14.9554 9.22643L18.5986 5.58324L19.2754 6.26484L14.9554 10.5848Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_458_34772",
    x: 9.2002,
    y: 3.19995,
    width: 13.6001,
    height: 13.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_458_34772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_458_34772",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/toggle-on.e4891751c4c4aebc0ec21d4d54b47b33.svg";
export { ForwardRef as ReactComponent };